/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable @typescript-eslint/no-unsafe-argument */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useState, useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import { Loader } from "@progress/kendo-react-indicators";
import { PDFExport } from "@progress/kendo-react-pdf";
import { getCustomerLogo, showToast } from "utils/helper";
import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbList,
  BreadcrumbPage,
  BreadcrumbSeparator,
  Button,
  Card,
  CardContent,
  Combobox,
  DatePicker,
} from "@repo/ui";
import { useGetCashCenters, useGetCustomers } from "utils/apis/lookups.api";
import { useGetCDMDiscrepanciesReport } from "utils/apis/reports.api";
import lynxLogo from "assets/images/logo.png";
import Layout from "components/layout";
import CMDDiscrepanciesGrid from "./cdmDiscrepanciesGrid";
import { formatDate } from "date-fns";

const currentDate = new Date();

function CdmDiscrepanciesReport() {
  const [requests, setRequests] = useState<any[]>([]);
  const [ddlCustomers, setDdlCustomers] = useState("");
  const [customer, setCustomer] = useState("--");
  const [ddlCashCenters, setDdlCashCenters] = useState("");
  const [cashCenter, setCashCenter] = useState("--");
  const [fromDate, setFromDate] = useState(currentDate);
  const [toDate, setToDate] = useState(currentDate);
  const [reportName, setReportName] = useState("");

  const pdfExportComponent = useRef<any>(null);

  const { data: customers } = useGetCustomers();
  const { data: cashCenters } = useGetCashCenters();

  const {
    data: requestData,
    mutate: getRequests,
    isPending: loading,
  } = useGetCDMDiscrepanciesReport();

  useEffect(() => {
    if (requestData?.requests?.length) {
      const requestsList = requestData?.requests?.map(
        (req: any, ind: number) => ({
          // eslint-disable-next-line no-param-reassign
          serialNo: ++ind,
          locationId: req.locationId,
          locationName: req.locationName,
          serviceDate: req.serviceDate,
          processingDate: req.processingDate,
          shortage: req.shortage,
          totalShortage: req.totalShortage,
          excess: req.excess,
          totalExcess: req.totalExcess,
        })
      );

      setRequests(requestsList);
    }
  }, [requestData]);

  const onDdlCashCentersChanged = (value: string) => {
    setDdlCashCenters(value);
    const cashCenterFound: any = cashCenters?.find(
      (c: any) => c.cashCenterId === value
    );
    setCashCenter(cashCenterFound.name);
  };

  const onDdlCustomersChanged = (value: string) => {
    setDdlCustomers(value);
    const customerFound: any = customers?.find(
      (c: any) => c.customerId === value
    );
    setCustomer(customerFound?.name);
  };

  const txtFromDateChanged = (value?: Date) => {
    if (value) {
      setFromDate(value);
    }
  };

  const txtToDateChanged = (value?: Date) => {
    if (value) {
      setToDate(value);
    }
  };

  const onBtnGenerateReportClicked = () => {
    if (!ddlCashCenters || !ddlCashCenters) {
      showToast("error", "Please select cash center.");
      return;
    }

    if (!ddlCustomers || !ddlCustomers) {
      showToast("error", "Please select customer.");
      return;
    }

    if (toDate.getDate() < fromDate.getDate()) {
      showToast("error", "To date can not be less than from date.");
      return;
    }

    const cashCenterId = ddlCashCenters;
    const customerId = ddlCustomers;

    const reportParams = {
      cashCenterId,
      customerId,
      fromDate: formatDate(fromDate, "yyyy-MM-dd'T'HH:mm:ss.SSS'Z'"),
      toDate: formatDate(toDate, "yyyy-MM-dd'T'HH:mm:ss.SSS'Z'"),
    };

    getRequests(reportParams);

    const rptName = `CDM_Discrepancies_${fromDate.getDate()}_${
      fromDate.getMonth() + 1
    }_${fromDate.getFullYear()}_to_${toDate.getDate()}_${
      toDate.getMonth() + 1
    }_${toDate.getFullYear()}`;

    setReportName(rptName);
  };

  const exportToPDF = () => {
    if (pdfExportComponent.current) {
      pdfExportComponent.current.save();
    }
  };

  return (
    <Layout>
      <Breadcrumb className="mt-5 mx-4">
        <BreadcrumbList>
          <BreadcrumbItem>
            <Link to="/dashboard">Home</Link>
          </BreadcrumbItem>
          <BreadcrumbSeparator />
          <BreadcrumbItem>
            <BreadcrumbPage>Reports</BreadcrumbPage>
          </BreadcrumbItem>
          <BreadcrumbSeparator />
          <BreadcrumbItem>
            <BreadcrumbPage>CDM Discrepancies Report</BreadcrumbPage>
          </BreadcrumbItem>
        </BreadcrumbList>
      </Breadcrumb>

      <Card className="mt-3 mx-4">
        <CardContent className="p-4">
          <div className="flex gap-3 mb-3">
            <div className="flex-1">
              <Combobox
                value={ddlCashCenters}
                data={cashCenters?.map((item) => ({
                  label: item?.name,
                  value: item?.cashCenterId,
                }))}
                placeholder="Select Cash Center"
                setValue={onDdlCashCentersChanged}
              />
            </div>
            <div className="flex-1">
              <Combobox
                value={ddlCustomers}
                data={customers?.map((st) => ({
                  value: st.customerId,
                  label: st.name,
                }))}
                placeholder="Select Customer"
                setValue={onDdlCustomersChanged}
              />
            </div>

            <div className="flex-1">
              <DatePicker
                placeholder="Select Report Start Date"
                selectedDate={fromDate}
                onSelectDate={txtFromDateChanged}
              />
            </div>

            <div className="flex-1">
              <DatePicker
                placeholder="Select Report End Date"
                selectedDate={toDate}
                onSelectDate={txtToDateChanged}
              />
            </div>

            <div className="flex-1 flex gap-3">
              <Button
                variant="secondary"
                className="w-full"
                onClick={onBtnGenerateReportClicked}
              >
                Get Report
              </Button>

              <Button
                variant="secondary"
                className="w-full"
                onClick={exportToPDF}
              >
                <span className="k-icon k-i-file-pdf k-i-pdf  k-icon-32  k-icon-color" />{" "}
                <svg viewBox="0 0 512 512" fill="currentColor" className="w-6">
                  <path d="M240.9 160c-7.6 0-13.8 4-15.4 9.9-4.9 18.6.2 46.3 9.4 82.3l-2.4 5.9c-6.6 16.4-14.8 33-22.1 47.6l-1 1.9c-7.7 15.3-14.6 28.4-21 39.4l-6.5 3.5c-.5.3-11.6 6.3-14.3 7.9-22.2 13.6-36.9 28.9-39.4 41.2-.8 3.9-.2 8.9 3.7 11.2l6.3 3.2c2.7 1.4 5.6 2.1 8.6 2.1 15.8 0 34.2-20.2 59.5-65.3 29.2-9.7 62.5-17.8 91.6-22.3 22.2 12.8 49.5 21.7 66.8 21.7q4.65 0 7.8-.9c3.3-.9 6.1-2.8 7.8-5.4 3.4-5.2 4-12.2 3.1-19.5-.3-2.1-2-4.8-3.8-6.6-5.1-5.2-16.5-7.9-33.7-8.1-11.7-.1-25.8.9-40.6 3-6.6-3.9-13.5-8.2-18.8-13.3-14.4-13.8-26.5-32.9-34-53.9.5-2 .9-3.7 1.3-5.4 0 0 8.1-47.1 6-63.1-.3-2.2-.5-2.8-1.1-4.5l-.7-1.9c-2.2-5.2-6.5-10.7-13.3-10.4zm2.7 8.4c5.1 0 8 13.1 8.2 25.4.3 12.3-2.6 20.9-6 27.3-2.9-9.4-4.3-24.3-4.3-34-.1-.1-.3-18.7 2.1-18.7m.4 104.1c8.6 16 19.3 29.5 31.9 40.4 1.6 1.3 3.2 2.7 5 4.1-25.6 5.2-47.7 11.5-67.1 19.1 3.6-6.5 7.2-13.3 11-20.6 9.1-17.7 14.9-31.6 19.2-43m102.2 51.6c9.3 0 12 0 21.1 2.3 9.1 2.4 9.2 7.2 7.6 8.2s-6 1.6-8.9 1.6c-9.2 0-20.7-4.3-36.8-11.4 6.3-.4 11.9-.7 17-.7m-165.4 35.8c-17.7 28.8-29.5 40.3-37.3 43.8 2.9-8.1 14.3-24 31.2-38.1 1.1-.9 3.7-3.4 6.1-5.7M352 32H96c-17.7 0-32 14.3-32 32v384c0 17.7 14.3 32 32 32h320c17.7 0 32-14.3 32-32V128zm64 416H96V64h224v96h96z" />
                </svg>
              </Button>

              {/* <Button className="btn btn-outline-icon" onClick={exportToPDF}>
              <span
                className={`k-icon k-i-file-excel k-i-file-xls k-i-excel k-i-xls k-icon-32 k-icon-color`}
              ></span>
            </Button> */}
            </div>
          </div>

          <div className="border-b my-3 bg-accent" />

          {loading ? (
            <div className="text-center" style={{ marginTop: -150 }}>
              <Loader size="large" type="converging-spinner" />
            </div>
          ) : null}
          <PDFExport
            scale={0.3}
            ref={pdfExportComponent}
            paperSize="A4"
            fileName={reportName}
          >
            <div className="p-4">
              <div className="flex gap-3 items-center">
                <div className="max-w-48 text-end">
                  <img src={lynxLogo} alt="logo" className="w-full" />
                </div>

                <div className="flex-1">
                  <span className="text-sm">{`Cash Center: ${cashCenter}`}</span>
                  <div className="border-b my-3 bg-accent" />
                  <span className="text-sm">{`Bank Name: ${customer}`}</span>
                  <div className="border-b my-3 bg-accent" />
                  <span className="text-sm">
                    {`From Date: ${
                      fromDate.getMonth() + 1
                    }/${fromDate.getDate()}/${fromDate.getFullYear()},  To Date: ${
                      toDate.getMonth() + 1
                    }/${toDate.getDate()}/${toDate.getFullYear()}`}
                  </span>
                  <div className="border-b my-3 bg-accent" />
                </div>
                <h5 className="flex-1 text-center underline">
                  CDM Discrepancies Report
                </h5>

                <div className="max-w-48 text-start">
                  <img
                    src={getCustomerLogo()}
                    className="w-full"
                    alt="customer-logo"
                  />
                </div>
              </div>

              {requests.length > 0 && (
                <CMDDiscrepanciesGrid requests={requests} />
              )}
            </div>
          </PDFExport>
        </CardContent>
      </Card>
    </Layout>
  );
}

export default CdmDiscrepanciesReport;
